import React from "react";

import CvSectionEdu from "./profile/CvSectionEdu";

import CvSectionProCarRes from "./professional/CvSectionProCarRes";
import CvSectionProEmpExp from "./professional/CvSectionProEmpExp";
import CvSectionProIndExp from "./professional/CvSectionProIndExp";

import CvSectionNonProWeb from "./non-professional/CvSectionNonProWeb";
import CvSectionNonProCol from "./non-professional/CvSectionNonProCol";

import CvSectionSkillsTranings from "./skills/CvSectionSkillsTranings";
import CvSectionSkillsLanguage from "./skills/CvSectionSkillsLanguage";
import CvSectionSkillsSoftware from "./skills/CvSectionSkillsSoftware";
import CvSectionSkills from "./skills/CvSectionSkills";

import * as cvSections from "../../util/CvSections";

import "./cv-sections.css";
import "./cv-sections-customs.css";

const cvSection = props => {
  let content = null;
  switch (props.title) {
    case cvSections.PROFILE_EDUCATION.title:
      content = <CvSectionEdu />;
      break;

    case cvSections.PRO_CAREER.title:
      content = <CvSectionProCarRes />;
      break;

    case cvSections.PRO_EMPLOYMENT.title:
      content = <CvSectionProEmpExp />;
      break;

    case cvSections.PRO_INDEPENDENT.title:
      content = <CvSectionProIndExp />;
      break;

    case cvSections.NONPRO_WEB.title:
      content = <CvSectionNonProWeb />;
      break;

    case cvSections.NONPRO_COLLABORATIONS.title:
      content = <CvSectionNonProCol />;
      break;

    case cvSections.SKILLS_TRANINGS.title:
      content = <CvSectionSkillsTranings />;
      break;

    case cvSections.SKILLS_LANGUAGE.title:
      content = <CvSectionSkillsLanguage />;
      break;

    case cvSections.SKILLS_SOFTWARE.title:
      content = <CvSectionSkillsSoftware />;
      break;

    case cvSections.SKILLS.title:
      content = <CvSectionSkills />;
      break;

    default:
      break;
  }

  return (
    <section className="Cv-sec Sec" id={props.id}>
      <div className="Sec__spacer"></div>
      <div className="Sec__container">
        <div className="cv-section__title">
          <div className="section-title bolder"> {props.title} </div>
        </div>
        <ul className="cv-section__items">{content}</ul>
      </div>
      <div className="Sec__spacer-end"></div>

    </section>
  );
};

export default cvSection;
